module.exports = __webpack_public_path__ + "img/kebijakan-lainnya.b7431ad8.svg";